const isSelfOnboardingEnabled = ({ globalInfo, globalInfoDataAvailable }) => {
    if (globalInfoDataAvailable) {
      return globalInfo && globalInfo.is_self_onboard_enabled ? true : false;
    }
    return true;
  }

export default isSelfOnboardingEnabled;
